export class Coordinate {
  latitudine: number;
  longitudine: number;
  }
